import styles from "./ButtonClose.module.css"

export default function ButtonClose({ stylesBis, onClick, ...props }) {
    return (
        <div className={`${stylesBis && stylesBis.close} ${styles.close}`}>
            <svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                className={styles.outClose} preserveAspectRatio={"none"}>
                <path
                    d="M50.6522 0.500007L5 0.500008C2.51472 0.500008 0.5 2.51472 0.5 5.00001L0.5 35C0.5 37.4853 2.51472 39.5 5 39.5L42.7411 39.5C44.122 39.5 45.4264 38.866 46.2795 37.7802L54.1906 27.7116C54.8135 26.9188 55.1522 25.9397 55.1522 24.9314L55.1522 5.00001C55.1522 2.51472 53.1375 0.500007 50.6522 0.500007Z"
                    fill="#92AFAE" stroke="#7991C4" />
            </svg>
            <button className={styles.btn} onClick={onClick}>
                <svg width="51" height="34" viewBox="0 0 51 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className={styles.innerClose} preserveAspectRatio={"none"}>
                    <path
                        d="M45.1739 0.743324L5.60864 0.743324C3.12336 0.743324 1.10864 2.75804 1.10864 5.24332L1.10864 28.7568C1.10864 31.2421 3.12335 33.2568 5.60863 33.2568L38.5008 33.2568C39.8346 33.2568 41.0996 32.6652 41.9546 31.6415L48.6276 23.652C49.3036 22.8427 49.6739 21.8217 49.6739 20.7673L49.6739 5.24332C49.6739 2.75804 47.6591 0.743324 45.1739 0.743324Z"
                        fill="#142432" stroke="#7991C4" />
                </svg>
                <span>X</span>
            </button>


        </div>
    )
}